// import React, { useEffect } from 'react'
// import OrderItemCard from './OrderItemCard'
// import { useAppDispatch, useAppSelector } from '../../../Redux Toolkit/Store';
// import { fetchUserOrderHistory } from '../../../Redux Toolkit/Customer/OrderSlice';
// import { Button } from '@mui/material';

// const Order = () => {
//   const dispatch = useAppDispatch()
//     const { cart, auth,orders } = useAppSelector(store => store);

//     useEffect(() => {
//         dispatch(fetchUserOrderHistory(localStorage.getItem("jwt") || ""))
//     }, [auth.jwt])
//   return (
//     <div className='text-sm min-h-screen'>
//        <div className='pb-5'>
//        <h1 className='font-semibold'>All orders
//         </h1>
//         <p>from anytime</p>
//        </div>
//         <div className='space-y-2'>
//             {orders?.orders?.map((order)=>order?.orderItems.map((item)=><OrderItemCard item={item} order={order}/>))}
//         </div>
        
//     </div>
//   )
// }

// export default Order
import React, { useEffect, useState } from 'react'
import OrderItemCard from './OrderItemCard'
import { useAppDispatch, useAppSelector } from '../../../Redux Toolkit/Store';
import { fetchUserOrderHistory } from '../../../Redux Toolkit/Customer/OrderSlice';
import { Button } from '@mui/material';

const ORDERS_PER_PAGE = 5;

const Order = () => {
  const dispatch = useAppDispatch();
  const { cart, auth, orders } = useAppSelector(store => store);
  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(fetchUserOrderHistory(localStorage.getItem("jwt") || ""))
  }, [auth.jwt]);

  const sortedOrders = (orders?.orders || []).slice().reverse(); // newest first
  const totalPages = Math.ceil(sortedOrders.length / ORDERS_PER_PAGE);
  const paginatedOrders = sortedOrders.slice(
    (page - 1) * ORDERS_PER_PAGE,
    page * ORDERS_PER_PAGE
  );

  return (
    <div className='text-sm min-h-screen'>
      <div className='pb-5'>
        <h1 className='font-semibold'>All orders</h1>
        <p>from anytime</p>
      </div>

      <div className='space-y-6'>
        {paginatedOrders.map(order => (
          <div key={order.id} className="border border-gray-200 p-4 rounded-md shadow-sm">
            <div className='font-medium text-gray-700 mb-3'>
              Order ID: OD102694500000{order.id}
            </div>
            <div className='space-y-2'>
              {order.orderItems.map(item => (
                <OrderItemCard key={item.id} item={item} order={order} />
              ))}
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="flex justify-center items-center gap-4 mt-6">
          <Button
            variant="outlined"
            onClick={() => setPage(prev => Math.max(prev - 1, 1))}
            disabled={page === 1}
          >
            Previous
          </Button>
          <span className="font-medium">Page {page} of {totalPages}</span>
          <Button
            variant="outlined"
            onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
            disabled={page === totalPages}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
};

export default Order;
